import React from "react";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

const DAYS = [
  { key: "monday", label: "M" },
  { key: "tuesday", label: "T" },
  { key: "wednesday", label: "W" },
  { key: "thursday", label: "T" },
  { key: "friday", label: "F" },
  { key: "saturday", label: "S" },
  { key: "sunday", label: "S" },
];



const WeekdayPicker = ({ selectedDays, onChange, disabled, name }) => {

  return (
    <ButtonGroup size="small">
        {DAYS.map((day, index) => (
          <Button name={`${name}|${index + 1}`} disabled={disabled} variant={selectedDays.includes(index + 1) ? "contained" : "outlined" } color="primary" onClick={onChange} key={day.key}>{day.label}</Button>
        ))}
    </ButtonGroup>
  )
};

// Default props
WeekdayPicker.defaultProps = {
  selectedDays: [],
  onChange: () => {},
  name: ""
};

export default WeekdayPicker;